import styled from 'styled-components';

export const QREnabledStyle = styled.div`
  display: flex;
  padding: 0 4px;
  span.qrIsNotSet {
    font-size: ${props => props.theme.fontSizeS};
    color: ${props => props.theme.uiColors.qrNotSet};
  }
`;
